import { ensureObject, ensureString } from "../../validate";
import { fetchJson } from "./http";
import {
  COURSES_BASE_URL,
  CoursesApiError,
  type SigninParams,
  type SigninResult,
} from "./types";

const FN = "GZIntegracoes.v1.cursos.signin";

/**
 * Verifica se um e-mail já está matriculado numa turma/curso e devolve o JWT
 * de acesso (usado depois em `content`).
 *
 * `enrolled: false` (HTTP 400 `{ signin: false }`) é um **resultado de negócio**,
 * não um erro — não lança. Falhas reais lançam `CoursesApiError`.
 */
export async function signin(params: SigninParams): Promise<SigninResult> {
  ensureObject(params, `${FN}(params)`);
  ensureString(params.email, `${FN} → params.email`);
  ensureString(params.className, `${FN} → params.className`);
  ensureString(params.courseName, `${FN} → params.courseName`);

  const { status, ok, body } = await fetchJson(
    `${COURSES_BASE_URL}/signin?token=true`,
    {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        email: params.email,
        className: params.className,
        courseName: params.courseName,
      }),
    },
  );

  const data = (body ?? {}) as { signin?: boolean; token?: string };

  if (ok) {
    return { enrolled: data.signin === true, token: data.token };
  }

  // 400 com `{ signin: false }` = não matriculado (resultado de negócio).
  if (status === 400 && data.signin === false) {
    return { enrolled: false };
  }

  throw new CoursesApiError(
    `${FN}: resposta inesperada da API (status ${status}).`,
    status,
    body,
  );
}
